import { makeStyles, Typography } from '@material-ui/core';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import React from 'react';
import RoundButton from 'Components/UI/RoundButton';

const useStyles = makeStyles(theme => ({
  noContent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    width: '100%',
    '& > p': {
      maxWidth: '50%',
    },
  },
  meetingHeader: {
    display: 'flex',
    margin: theme.spacing(2, 0, 0, 0),
  },
  meetingTitle: {
    marginBottom: theme.spacing(2),
    flex: '1 0 0',
  },
  zoomButton: {
    flex: '1 0 0',
    marginBottom: theme.spacing(2),
    display: 'flex',
    justifyContent: 'flex-end',
  },
  meetingContent: {
    borderTop: '8px solid',
    borderImageSlice: 1,
    borderWidth: 5,
    borderImageSource: `linear-gradient(to right, ${theme.palette.primary.main}, ${theme.palette.facet.accentBlue})`,
    padding: theme.spacing(2),
    minHeight: theme.dimensions.sm,
    maxHeight: theme.dimensions.md,
    minWidth: theme.dimensions.sm,
    display: 'flex',
    justifyContent: 'flex-start',
    overflow: 'auto',
  },
  [theme.breakpoints.down('sm')]: {
    meetingHeader: {
      flexFlow: 'column',
    },
    zoomButton: {
      flex: '1 0 0',
      marginBottom: theme.spacing(2),
      display: 'flex',
      justifyContent: 'flex-start',
    },
  },
}));

export default function MeetingHeader({ meeting }) {
  const classes = useStyles();

  const link = meeting.attr('link');
  const linkDisabled = link.length === 0;
  return meeting
    && (
    <div className={classes.meetingHeader}>
      <Typography
        className={classes.meetingTitle}
        variant="h4"
        color="primary"
      >
        {`${meeting.attr('title')}, ${moment(
          meeting.attr('startTime'),
        ).format('M/D/YY, h:mmA')} ${moment.tz
          .zone(moment.tz.guess())
          .abbr(Date.now())}`}
      </Typography>
      <div className={classes.zoomButton}>
        <RoundButton
          color="secondary"
          component="a"
          disabled={linkDisabled}
          disableElevation
          href={link}
          target="_blank"
          variant="contained"
        >
          {linkDisabled ? 'Zoom Link Not Found' : 'Launch Zoom'}
        </RoundButton>
      </div>
    </div>
    );
}

MeetingHeader.propTypes = {
  meeting: PropTypes.object.isRequired,
};
